define(["cleave/cleave"], function (Cleave) {
    'use strict';

    return (conf, elem) => {
        // eslint-disable-next-line no-new
        new Cleave(elem, conf);
    };
});
